import { Cancel } from '@mui/icons-material';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    // Function to open the HelpScout Beacon chat widget
    const openChatSupport = () => {
        if (window.Beacon) {
            window.Beacon('open');
            window.Beacon('navigate', '/ask/message');
        }
    };

    return (
        <Paper sx={{
            maxWidth: 600,
            mx: 'auto',
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            borderRadius: 2,
            boxShadow: 3
        }}>
            <Cancel sx={{
                fontSize: 64,
                color: 'error.main',
                mb: 2
            }} />

            <Typography variant="h4" gutterBottom>
                {t('plans.payment.cancel.title')}
            </Typography>

            <Typography variant="body1" sx={{ mb: 4 }}>
                {t('plans.payment.cancel.description')}
            </Typography>

            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2
            }}>
                <Button variant="contained" color="primary" onClick={() => navigate('/plans')} sx={{ mr: 2 }}>
                    {t('plans.payment.cancel.button')}
                </Button>
                <Button variant="outlined" onClick={openChatSupport}>
                    Contact Support
                </Button>
            </Box>
        </Paper>
    );
};

export default PaymentCancel;
